var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 4.87344H6.21875V1.24844C6.21875 1.05616 6.14303 0.871749 6.00823 0.735785C5.87344 0.599821 5.69062 0.523438 5.5 0.523438C5.30938 0.523438 5.12656 0.599821 4.99177 0.735785C4.85698 0.871749 4.78125 1.05616 4.78125 1.24844V4.87344H1.1875C0.996876 4.87344 0.814059 4.94982 0.679267 5.08579C0.544475 5.22175 0.46875 5.40616 0.46875 5.59844C0.46875 5.79072 0.544475 5.97513 0.679267 6.11109C0.814059 6.24705 0.996876 6.32344 1.1875 6.32344H4.78125V9.94844C4.78125 10.1407 4.85698 10.3251 4.99177 10.4611C5.12656 10.5971 5.30938 10.6734 5.5 10.6734C5.69062 10.6734 5.87344 10.5971 6.00823 10.4611C6.14303 10.3251 6.21875 10.1407 6.21875 9.94844V6.32344H9.8125C10.0031 6.32344 10.1859 6.24705 10.3207 6.11109C10.4555 5.97513 10.5312 5.79072 10.5312 5.59844C10.5312 5.40616 10.4555 5.22175 10.3207 5.08579C10.1859 4.94982 10.0031 4.87344 9.8125 4.87344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGrey);
export default __webpack_public_path__ + "static/media/plus-grey.ab9378a321422cc52d9d98a1e6dd601c.svg";
export { ForwardRef as ReactComponent };